import { render } from "./InvestmentPending.vue?vue&type=template&id=1af92ee2&scoped=true&ts=true"
import script from "./InvestmentPending.vue?vue&type=script&lang=ts"
export * from "./InvestmentPending.vue?vue&type=script&lang=ts"

import "./InvestmentPending.vue?vue&type=style&index=0&id=1af92ee2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af92ee2"]])

export default __exports__